
import { Button, Card, CardBody, CardFooter, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'

const ReactivarViaje = ({ShowReactivarViaje,setShowReactivarViaje,SelectedReactivarViajeId,postSaveReactive,titles='Reactivar el viaje',textBotton='Si, Reactivar',}) => {
  return (
    <Modal
    key={"disassociate"}
    size="sm"
    fade={false}
    centered={true}
    isOpen={ShowReactivarViaje}
    toggle={() => setShowReactivarViaje(!ShowReactivarViaje)}
    backdrop="static"
    keyboard={false}
  >
    <ModalHeader toggle={() => setShowReactivarViaje(!ShowReactivarViaje)}>
      {titles}
    </ModalHeader>
    <ModalBody>
      <Col lg={12}>
        <Card>
          <CardBody>
            <p> ¿Realmente desea {titles}? </p>
          </CardBody>
          <CardFooter>
            <Row>
              <div className="text-sm-center block-inline">
                <Button
                  className="btn"
                  color="link"
                  onClick={() => setShowReactivarViaje(false)}
                >
                  Cerrar
                </Button>{" "}
                <Button
                  className="btn"
                  color="success"
                  onClick={() => {
                    if (SelectedReactivarViajeId) {
                      const objReactive = {DocumentId:SelectedReactivarViajeId}
                      postSaveReactive({objReactive,setShowReactivarViaje:(e)=> setShowReactivarViaje(e)})
                    }

                  }}
                >
                  {textBotton}
                </Button>
              </div>
            </Row>
          </CardFooter>
        </Card>
      </Col>
    </ModalBody>
  </Modal>
  )
}

export default ReactivarViaje